/** Shared motion easing — used by marketing and dashboard surfaces. */
export const EASE_REFINED = [0.22, 1, 0.36, 1];
export const EASE_LUXURY = [0.25, 0.46, 0.45, 0.94];
